import { ServiceConfig } from 'angular-odata';

//#region ODataApi Imports
//#endregion

export const ArtikelServiceConfig = {
  name: "Artikel",
  annotations: []
} as ServiceConfig;